import { isAdminOfOrganization } from '../organization/isAdminOfOrganization';
import type { isMemberOfOrganization } from '../organization/isMemberOfOrganization';
import { getMemberTypeFromBoard } from './getMemberTypeFromBoard';
import { isEditableByOrganizationMember } from './isEditableByOrganizationMember';

/**
 * Checks if a member has edit permissions on the board.
 */
export const canEdit = (
  member: {
    id: string;
    idEnterprisesAdmin: Array<string>;
    idPremOrgsAdmin: Array<string>;
    memberType: 'ghost' | 'normal';
  },
  board: {
    prefs?: { isTemplate: boolean; selfJoin: boolean } | null;
    memberships: {
      id: string;
      deactivated: boolean;
      idMember: string;
      memberType: 'admin' | 'normal' | 'observer';
      unconfirmed: boolean;
    }[];
    closed: boolean;
  },
  organization:
    | ({ id: string; offering: string } & {
        memberships: {
          id: string;
          deactivated: boolean;
          idMember: string;
          memberType: 'admin' | 'normal';
          unconfirmed: boolean;
        }[];
        enterprise?: {
          id?: string;
          idAdmins?: Array<string>;
        } | null;
      })
    | null,
  enterprise: Parameters<typeof isMemberOfOrganization>[2] | null,
): boolean => {
  if (board.closed) {
    return false;
  }

  const memberType = getMemberTypeFromBoard(member, board, organization);

  const isWorkspaceAdmin =
    organization && isAdminOfOrganization(member, organization, enterprise);

  if ('observer' === memberType && !isWorkspaceAdmin) {
    return false;
  }

  // existing board members can edit
  if (['admin', 'normal'].includes(memberType)) {
    return true;
  }

  return isEditableByOrganizationMember(member, board, organization);
};
